"use client"

import { format, setHours, setMinutes, subDays } from "date-fns"
import { useState } from "react"
import { DatePickerWithRange } from "../../../components/ui/date-range-picker"
import { ScrollArea } from "../../../components/ui/scroll-area"
import { Overview } from "../charts/overview"

export default function DashboardsPage() {
  const parseDateWithoutTimezone = (date: string, isFirst = true) => {
    const dateWithCorrectHours = setHours(new Date(date), isFirst ? 0 : 23)
    const dateWithCorrectHoursAndMinutes = setMinutes(dateWithCorrectHours, isFirst ? 0 : 59)
    return format(dateWithCorrectHoursAndMinutes, `yyyy-MM-dd HH:mm:ss`).replace(" ", "T")
  }

  const [date, setDate] = useState(() => ({
    from: parseDateWithoutTimezone(subDays(new Date(), 30).toString()),
    to: parseDateWithoutTimezone(new Date().toString(), false),
  }))

  return (
    <div className="w-full">
      <main className="flex flex-col gap-6">
        <div className="flex flex-wrap justify-between min-h-10 mt-4 items-center gap-2">
          <h3 className="text-2xl font-bold">Visão Geral</h3>
          <DatePickerWithRange
            setInitDate={(value) => setDate({ ...date, from: parseDateWithoutTimezone(value) })}
            setFinishDate={(value) => setDate({ ...date, to: parseDateWithoutTimezone(value, false) })}
          />
        </div>

        <ScrollArea className="h-container-graphics">
          <div className="">
            <Overview dataFinal={date.to} dataInicial={date.from} />
          </div>
        </ScrollArea>
      </main>
    </div>
  )
}
